import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Snack from '@material-ui/core/Snackbar';
import IconButton from '@material-ui/core/IconButton';
import Close from '@material-ui/icons/Close';
import snackbarContentStyle from './SnackbarContentStyle';

function Snackbar({ ...props }) {
    const {
        classes, message, color, close, icon, place, open,
    } = props;
    let action = [];
    const messageClasses = clsx({
        [classes.iconMessage]: icon !== undefined,
    });
    if (close !== undefined) {
        action = [
            <IconButton
                className={classes.iconButton}
                key='close'
                aria-label='Close'
                color='inherit'
                onClick={() => props.closeNotification()}
            >
                <Close className={classes.close}/>
            </IconButton>,
        ];
    }
    return (
        <Snack
            anchorOrigin={{
                vertical: place.indexOf('t') === -1 ? 'bottom' : 'top',
                // eslint-disable-next-line no-nested-ternary
                horizontal: place.indexOf('l') !== -1 ? 'left' : place.indexOf('c') !== -1 ? 'center' : 'right',
            }}
            open={open}
            message={
                <div>
                    {icon !== undefined ? <props.icon className={classes.icon}/> : null}
                    <span className={messageClasses}>{message}</span>
                </div>
            }
            action={action}
            classes={{
                root: classes.container,
            }}
            ContentProps={{
                classes: {
                    root: `${classes.root} ${classes[color]}`,
                    message: classes.message,
                },
            }}
        />
    );
}

Snackbar.propTypes = {
    classes: PropTypes.object.isRequired,
    message: PropTypes.node.isRequired,
    color: PropTypes.oneOf(['info', 'success', 'warning', 'danger', 'primary']),
    close: PropTypes.bool,
    place: PropTypes.oneOf(['tl', 'tr', 'tc', 'br', 'bl', 'bc']),
    open: PropTypes.bool,
};

export default withStyles(snackbarContentStyle)(Snackbar);
